<template>
  <div class="comp-container" :class="{ 'comp-container__h5': isH5 }">
    <div class="back" @click="goBack">
      <img :src="arrowLeftImg" alt="" />返回
    </div>
    <div class="code-content">
      <div class="title">
        <h3>绑定手机</h3>
        <p>
          应《中华人民共和国网络安全法》要求，我们将进一步强化实名认证机制。
        </p>
        <p>为全面体验产品服务，烦请您绑定手机号。</p>
      </div>
      <div class="code-container">
        <input-phone
          :mobile.sync="loginForm.mobile"
          :code.sync="loginForm.region_num"
          :code-list="codeList"
          fixedCode="86"
        />
      </div>
    </div>
    <div class="footer">
      <el-button
        type="primary"
        class="next-step"
        :disabled="loginForm.mobile.length !== 11"
        @click="nextStep"
      >
        发送验证码
      </el-button>
    </div>
  </div>
</template>

<script>
import ManMachineVerify from "@saas/components/src/mixins/manMachineVerify";
import Login from "@saas/components/src/mixins/login";
import InputPhone from "./InputPhone";
import { mapState } from "vuex";
import { isH5 } from "@saas/components/src";
export default {
  components: {
    InputPhone,
  },
  mixins: [ManMachineVerify, Login],
  props: {
    // // login 登录 register 注册
    // type: {
    //   type: String,
    //   default: "login",
    // },
  },
  data() {
    return {
      arrowLeftImg: require("../../../assets/images/login/arrow-left.png"),
      // 验证结果
      verifyRes: "",
      // 是否验证中
      isVerifying: false,
      code: "",
      isH5: isH5(),
      //   returnUrl: null
    };
  },
  computed: {
    ...mapState("user", ["loginForm"]),
    codeList() {
      return this.$store.state.user.areaCodeList || [];
    },
  },
  mounted() {},
  methods: {
    nextStep() {
      // 发送验证码前需要人机验证
      this.captcha.show();
    },
    // 人机验证回调
    captchaCallback(res) {
      try {
        if (res.ret === 0) {
          this.sendVerifyCode(res);
        } else {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 发送验证码
    sendVerifyCode(res) {
      this.$store
        .dispatch("user/sendCode", {
          account: this.loginForm.mobile,
          region_num: this.loginForm.region_num
            ? this.loginForm.region_num + ""
            : "",
          randstr: res.randstr,
          scene: "QuickLogin",
          ticket: res.ticket,
        })
        .then((res) => {
          if (res.code === 1) {
            this.$emit("sendCodeSuccess", "register");
          }
        })
        .catch(() => {});
    },
    goBack() {
      this.$emit("back");
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 480px;
  height: 550px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 55px 48px 50px 48px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(156, 175, 154, 0.17);
  border-radius: 24px;
  .back {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    color: #515350;
    line-height: 22px;
    img {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 3px;
    }
  }
  .code-content {
    flex: 1;
    margin: 0;
    margin-top: 16px;
    .title {
      h3 {
        font-weight: 500;
        margin: 0;
        font-size: 24px;
        color: $saas-text-color;
        line-height: 33px;
      }
      p {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
        margin-top: 8px;
        &:last-child {
          color: #ff7700;
        }
        span {
          color: rgba(13, 20, 0, 1);
          font-weight: normal;
        }
      }
    }
    .code-container {
      margin-top: 30px;
      .refresh-btn {
        font-weight: normal;
        font-size: 14px;
        margin-top: 16px;
        color: rgba(0, 200, 157, 1);
      }
      .refresh-btn-disabled {
        color: #515350;
      }
      .el-button {
        margin-bottom: 8px;
        padding: 5px 0;
      }
    }
  }
  .footer {
    width: 100%;
    .next-step {
      width: 100%;
      height: 50px;
      border-radius: 16px !important;
      border: none;
      font-weight: 600;
      font-size: 16px;
      background: linear-gradient(
        132deg,
        rgba(0, 235, 129, 1) 0%,
        rgba(0, 200, 157, 1) 100%
      ) !important;
      color: #fff !important;
      &:hover {
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1) 0%,
          rgba(0, 200, 157, 1) 100%
        ) !important;
        color: #fff !important;
      }
      &:focus {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1) 0%,
          rgba(0, 200, 157, 1) 100%
        ) !important;
      }
      &.is-disabled {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 0.5) 0%,
          rgba(0, 200, 157, 0.5) 100%
        ) !important;
        &:hover {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 0.5) 0%,
            rgba(0, 200, 157, 0.5) 100%
          ) !important;
        }
        &:focus {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 0.5) 0%,
            rgba(0, 200, 157, 0.5) 100%
          ) !important;
        }
      }
    }
  }
}
.comp-container__h5 {
  width: 100%;
  height: 100%;
  padding: 0.3067rem 0.64rem 0.6667rem 0.64rem;
  box-shadow: none;
  border-radius: 0;
  .back {
    position: absolute;
    left: 0.5067rem;
    top: 0.4rem;
    font-size: 0.4267rem;
    line-height: 0.6rem;
    img {
      width: 0.4267rem;
      height: 0.4267rem;
      margin-right: 0.16rem;
    }
  }
  .code-content {
    margin: 0;
    margin-top: 2.4rem;
    .title {
      h3 {
        font-size: 0.5333rem;
        line-height: 0.7467rem;
      }
      p {
        font-size: 0.3467rem;
        line-height: 0.4933rem;
        margin-top: 0.2667rem;
      }
    }
    .code-container {
      margin-top: 1.2rem;
      .refresh-btn {
        margin-top: 0.4rem;
        font-size: 0.3467rem;
      }
      .el-button {
        margin-bottom: 1.3867rem;
      }
    }
  }
  .footer {
    width: 100%;
    margin-top: 1rem;
    .next-step {
      width: 100%;
      height: 1.3333rem;
      font-size: 0.4267rem;
      border-radius: 0.4267rem !important;
    }
  }
}

@keyframes identifier {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
